import { buildReferralQrImageUrl } from '../../services/parrainageService';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/jconsult-academia-logo.png`;

type Props = {
  registerUrl: string;
  size?: number;
  className?: string;
  alt?: string;
};

export default function ReferralQrWithLogo({
  registerUrl,
  size = 240,
  className = '',
  alt = 'QR code',
}: Props) {
  if (!registerUrl) return null;

  const logoSize = Math.max(44, Math.round(size * 0.22));

  return (
    <div
      className={`relative inline-flex shrink-0 items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={buildReferralQrImageUrl(registerUrl, size)}
        alt={alt}
        width={size}
        height={size}
        className="rounded-lg"
      />
      <img
        src={LOGO_SRC}
        alt=""
        aria-hidden
        className="absolute left-1/2 top-1/2 rounded-xl bg-white object-contain shadow-sm"
        style={{
          width: logoSize,
          height: logoSize,
          transform: 'translate(-50%, -50%)',
          padding: 4,
        }}
      />
    </div>
  );
}
